import { render, staticRenderFns } from "./ReservationLogCard.vue?vue&type=template&id=0a25e39c"
import script from "./ReservationLogCard.vue?vue&type=script&lang=js"
export * from "./ReservationLogCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports